import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip'
import { Field, reduxForm, Form } from 'redux-form';
import Button from 'material-ui/Button';

import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';

import renderTextField from '../../helpers/RenderTextFiledWithDiv';
import validationHelper from '../../helpers/ValidationHelper';

import autotecStyle from '../../components/Styles/style';

const validate = (values) => {
  const errors = validationHelper.validateRequired(['token', 'newPassord', 'confirmPassword'], values);
  if (values.token && values.token.length < 6) {
    errors.token = 'Token must be 6 characters in length';
  }

  if (values.newPassword > 25
    || values.newPassword < 16
    || !/\d/.test(values.newPassword)
    || !/[~`!#$%@\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(values.newPassword)) {
      errors.newPassword = 'Password does not meet criteria'
    }

  if (values.newPassword !== values.confirmPassword) {
    errors.confirmPassword = 'Passwords must match';
  }
  return errors;
};

const linkStyle = {
  paddingTop: '2%',
  marginLeft: '44%',
  display: 'block',
  color: '#002053',
  width: 55,
  height: 23,
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: 'normal',
  fontSize: 14,
  textAlign: 'center',
  textDecoration: 'none'
};

class ForgotPasswordReset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: ''
    };
  }

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

  handleSave = (event) => {
    this.props.forgotPasswordReset(this.props.username, event.token, event.newPassword);
  }

  handlePasswordChange(e) {
    console.log('state is changing')
    this.setState({ newPassword: e.target.value});
  }

  render() {
    const { classes, handleSubmit } = this.props;
    return (
      <div>
        <Form onSubmit={handleSubmit(this.handleSave)}>
          <div style={{ paddingTop: '37px' }}>
            <Field
              name="token"
              style={{ width: '238px' }}
              component={renderTextField}
              label="Verification Code"
              className={classes.textField}
              divClassName={classes.marginStyle}
            />
            <Field
              name="newPassword"
              style={{ width: '238px', marginBottom: '2%' }}
              component={renderTextField}
              label="New Password"
              onChange={e => this.handlePasswordChange(e)}
              className={classes.textField}
              divClassName={classes.marginStyle}
              password
              data-tip="Password must contain at least 16 but not exceed 25 characters<br />Password must contain at least one number<br />Password must contain at least one special character<br />Password must contain at least one uppercase character"
            />
            <ReactTooltip
              place="bottom"
              effect="solid"
              multiline
              event="focusin"
              eventOff="focusout"
            />
            <Field
              name="confirmPassword"
              style={{ width: '238px' }}
              component={renderTextField}
              label="Confirm Password"
              className={classes.textField}
              divClassName={classes.marginStyle}
              password
            />
          </div>
          <div style={{ paddingTop: '11%', paddingBottom: '0', marginBottom: '0' }}>
            <Button
              style={{ marginTop: '10px', width: '123px', padding: '0' }}
              className={classes.buttonStyle}
              variant="raised"
              color="primary"
              type="submit">
                Change Password
            </Button>
          </div>
          <a style={linkStyle} href='#' onClick={e => this.props.showLoginDialog(e)} variant="raised" color="primary">Back</a>
        </Form>
      </div>
    );
  }
}

ForgotPasswordReset.propTypes = {
  classes: PropTypes.shape().isRequired
};

export default withStyles(autotecStyle, { withTheme: true })(reduxForm({ form: 'ForgotPasswordForm', validate })(ForgotPasswordReset));


// WEBPACK FOOTER //
// ./src/components/User/ForgotPasswordReset.js